<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    
    <div class="aside-hd">

      <div class="shop-info-b">
        <i class="el-icon-s-shop"></i>
      </div>

      <span style=" margin-left: 5px; font-size: 14px;" v-if="!isCollapse">商家管理后台</span>
    </div>
    
    <el-menu :collapse="isCollapse" router :default-active="$route.path" class="el-menu-width">

      <!-- <el-menu-item index="/workbench"><i class="el-icon-monitor"></i><span slot="title">工作台</span></el-menu-item> -->
      <el-menu-item index="/addorder" v-if="!isChef"><i class="el-icon-thumb"></i><span slot="title">点餐</span></el-menu-item>
      <el-menu-item index="/table" v-if="isAdmin"><i class="el-icon-table-lamp"></i><span slot="title">桌位管理</span></el-menu-item>
      <el-menu-item index="/qrCode" v-if="isAdmin"><i class="el-icon-full-screen"></i><span slot="title">桌号管理</span></el-menu-item>
      <el-menu-item index="/order" v-if="!isChef"><i class="el-icon-coin"></i><span slot="title">订单管理</span></el-menu-item>
      <el-menu-item index="/goods" v-if="isAdmin"><i class="el-icon-dish"></i><span slot="title">菜品管理</span></el-menu-item>
      <el-menu-item index="/category" v-if="isAdmin"><i class="el-icon-copy-document"></i><span slot="title">分类管理</span></el-menu-item>
      <el-menu-item index="/employee" v-if="isAdmin"><i class="el-icon-user"></i><span slot="title">员工管理</span></el-menu-item>
      <!-- <el-menu-item index="/user" v-if="isAdmin"><i class="el-icon-service"></i><span slot="title">用户管理</span></el-menu-item> -->
      <el-menu-item index="/set" v-if="isAdmin"><i class="el-icon-setting"></i><span slot="title">店铺配置</span></el-menu-item>
      <el-menu-item index="/dashboard" v-if="!isChef"><i class="el-icon-pie-chart"></i><span slot="title">数据统计</span></el-menu-item>
      <!-- <el-menu-item index="/acctbook"><i class="el-icon-data-analysis"></i><span slot="title">收支统计</span></el-menu-item> -->
      <el-menu-item index="/printer" v-if="isAdmin"><i class="el-icon-printer"></i><span slot="title">打印机</span></el-menu-item>
      <el-menu-item index="/cheftask" v-if="isAdmin || isChef"><i class="el-icon-takeaway-box"></i><span slot="title">后厨任务</span></el-menu-item>
      <!-- 与用户对话 信息/对话/会话管理-->
      <!-- <el-menu-item index="/cheftask" v-if="isAdmin"><i class="el-icon-chat-dot-round"></i><span slot="title">对话框</span></el-menu-item> -->
    </el-menu>

    <!-- submenu收起 el-menu-item-group分组 -->
    <!-- <el-menu :collapse="isCollapse" router :default-active="$route.path" class="el-menu-width">
      <el-submenu index="1">
        <template></template>
      </el-submenu>
 

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-coin"></i>
          <span>订单管理</span>
        </template>

        <el-menu-item-group>
          <el-menu-item index="2-1">添加订单</el-menu-item>
          <el-menu-item index="2-2">修改订单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-menu-item index="2"><i class="el-icon-s-goods"></i><span>商品管理</span></el-menu-item>


    </el-menu> -->



    <div class="aside-ft-b">
   
      <div class="arrow-b" @click="isCollapse = !isCollapse">

        <i class="el-icon-s-fold" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" v-if="isCollapse"></i>

      </div>

    </div>

  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        isCollapse: false,
      }
    },

    computed:{
      
      isAdmin() {
        return localStorage.getItem('loginUser') === 'admin';
      },

      isChef() {
        return localStorage.getItem('loginUser') === '后厨';
      }

    }

  }      
</script>

<style scoped>
    .aside-hd {
      position: sticky;
      top: 0;
      z-index: 10;
      min-height: 50px;
      font-size: 14px;
      color: #333;
      background-color: #ffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .shop-info-b {
      width: 35px;
      height: 35px;
      background-color: #fff;
      border-radius: 15px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .shop-info-b i {
      font-size: 24px; 
    }

    /* #region */
    .el-menu {
      box-sizing: border-box;
      padding: 0 15px 0 12px;
      border-right: 0;
      background-color: initial;
    }

    .el-menu-item {
      font-size: 13px;
      height: 40px;
      line-height: 40px;
      margin-bottom: 5px;
      letter-spacing: 0.8px;
      background-color: #f8f8f8be;
      border-radius: 10px;
      /* border-radius: 4px; */
    }

    .el-menu-item i {
      width: 20px;
      text-align: center;
      color: #000;
      font-size: 18px;
    }

    .el-menu-item span {
      box-sizing: border-box;
      padding-left: 5px;
    }

    /* 左侧栏展开 *//* 在Element收缩侧边栏一定配置 */
    .el-menu-width:not(.el-menu--collapse) { /* :not伪类选择器，排除同时拥有()中类的元素 */
      width: 200px;
    }

    /* 修改左侧栏收起 */
    /* .el-menu--collapse {
      width: 80px;
    } */
    
    /* 修改icon的位置 */
    ::v-deep .el-menu-item div {
      left: -12px !important;
    }

    /* 左侧栏-鼠标悬浮背景色 */
    .el-menu-item:hover {
      background-color: #e1effe;
    }
    
    /* 左侧栏-鼠标点击后添加此样式 */
    /* 选中项的背景色持续生效 */
    ::v-deep .el-menu-item.is-active {
      color: #fff;
      background-color: #df0000;
    }
    ::v-deep .el-menu-item.is-active i {
      color: #fff;
    }
    
    /* 隐藏默认显示提示文字焦点时的边框 */
    ::v-deep .focusing {
      outline: none !important;
    }

    /* 修改默认左侧栏展开收起速度 */
    ::v-deep .horizontal-collapse-transition {
      transition: all 0.2s !important;
    }

    .aside-ft-b {
      margin-top: auto;
      min-height: 40px;
      font-size: 13px;
      color: #333;
      text-align: center;
    }

    .arrow-b {
      width: 25px;
      height: 25px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: #333;
      border-radius: 20px;
      cursor: pointer;
    }
  
    .aside-ft-b i {
      font-size: 14px;
      color: #fff;
    }
    
    /* #endregion */

</style>